import { PostFormat } from 'sharedKernel/api'
import { regexPatterns } from 'sharedKernel/regex'
import { ICaixaEmployeeRegisterFormValues } from '../store'

const CAIXA_EMPLOYEE_REGISTER_ID = '00000000-0000-0000-0000-000000000000'

interface ICaixaEmployeeRegisterData {
  contactName: string
  email: string
  matricula: string
  password: string
  confirmPassword: string
  contact: {
    phone: string
    mobile: string
  }
  language: string
  timezone: string
  caixaRole: string
  caixaInstitution: string
  caixaDepartment: string
  evaluatorType: string
  evaluatorRole: string
  evaluatorInstitution: string
  evaluatorDepartment: string
  evaluatorEducation: string
}

export const createCaixaEmployeeRegisterRequest = (
  form: ICaixaEmployeeRegisterFormValues,
  url: string
): PostFormat => {
  return {
    url,
    data: transformFormDataToPostObject(form)
  }
}

const transformFormDataToPostObject = (
  form: ICaixaEmployeeRegisterFormValues
): { id: string; data: ICaixaEmployeeRegisterData } => {
  const cleanObject = Object.fromEntries(
    Object.entries(form).map(([key, value]) => [key, value.value])
  )

  const phoneDigits = (cleanObject.phone ?? '').replace(regexPatterns.clearMaskedNumbers, '')

  const data: ICaixaEmployeeRegisterData = {
    contactName: cleanObject.contactName,
    email: cleanObject.email,
    matricula: cleanObject.caixaMatricula,
    password: cleanObject.password,
    confirmPassword: cleanObject.confirmPassword,
    contact: {
      phone: phoneDigits,
      mobile: phoneDigits
    },
    language: 'pt-BR',
    timezone: 'America/Sao_Paulo',
    caixaRole: cleanObject.caixaRole,
    caixaInstitution: cleanObject.caixaInstitution,
    caixaDepartment: cleanObject.caixaDepartment,
    evaluatorType: '',
    evaluatorRole: '',
    evaluatorInstitution: '',
    evaluatorDepartment: '',
    evaluatorEducation: ''
  }

  return { id: CAIXA_EMPLOYEE_REGISTER_ID, data }
}
